import { render, staticRenderFns } from "./orgModules.vue?vue&type=template&id=4e62d401&scoped=true&"
import script from "./orgModules.vue?vue&type=script&lang=js&"
export * from "./orgModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e62d401",
  null
  
)

export default component.exports